import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-roll-fin-form',
  templateUrl: './time-roll-fin-form.component.html',
  styleUrls: ['./time-roll-fin-form.component.css']
})
export class TimeRollFinFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Attendance-Leaves/time-roll-finalization/time-roll-fin-form/time-roll-fin-form.component.ts